module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "org-channel-config-dialog",
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "招商渠道优先级配置",
      "close-on-click-modal": false,
      "append-to-body": true,
      "width": "70%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleCancel
    }
  }, [_c('el-table', {
    attrs: {
      "max-height": "500",
      "size": "small",
      "data": _vm.currentItem.orgChannelConfigs || [],
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-table', {
          attrs: {
            "data": row.shops,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "选择",
            "align": "center",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var childRow = ref.row;

              return [_c('el-checkbox', {
                on: {
                  "change": function($event) {
                    return _vm.changeRadio($event, childRow, row.shops)
                  }
                },
                model: {
                  value: (childRow.selected),
                  callback: function($$v) {
                    _vm.$set(childRow, "selected", $$v)
                  },
                  expression: "childRow.selected"
                }
              })]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "departmentName",
            "label": "实体门店名称",
            "show-overflow-tooltip": true,
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "shopAddress",
            "label": "实体门店地址",
            "show-overflow-tooltip": true,
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "departmentNo",
            "label": "实体门店编码",
            "show-overflow-tooltip": true,
            "align": "center"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优先级",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-input-number', {
          attrs: {
            "size": "small",
            "min": 1,
            "precision": 0
          },
          model: {
            value: (row.priority),
            callback: function($$v) {
              _vm.$set(row, "priority", $$v)
            },
            expression: "row.priority"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgChannelName",
      "label": "招商渠道",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgBelongMarketClassifyName",
      "label": "所属事业线",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgBelongClassifySalesName",
      "label": "所属经销部",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgForbiddenStatusName",
      "label": "状态",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgMarketManageRightCode",
      "label": "经营权编码",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b9d32b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/orgChannelConfigDialog.vue
// module id = 2422
// module chunks = 68